import { StyleProps, CSS } from "@shared/primitive-components"

export const chartWrap = (props: StyleProps) => ({
  marginBottom: props.theme.spacing(4),
  padding: 0,
  width: `100%`,
  "& .mdc-layout-grid__inner": {
    "@media (min-width: 840px)": {
      "@supports(display: grid)": {
        gridTemplateColumns: `repeat(8, minmax(0, 1fr))`,
      },
    },
  },
})

export const chartItem = (props: StyleProps) => ({
  width: `100%`,
  "@supports(display: grid)": {
    width: `auto`,
    gridColumnEnd: `span 8`,
  },
  [props.theme.breakPoints.xl.up]: {
    width: `calc(50% - var(--mdc-layout-grid-gutter-desktop, 16px))`,
    "@supports(display: grid)": {
      width: `auto`,
      gridColumnEnd: `span 4`,
    },
  },
})

export const marginBottom = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})

export const emptyChartCard = () => ({
  display: `flex`,
})

export const subtitle = (props: StyleProps): CSS => ({
  marginBottom: props.theme.spacing(6),
})

export const loaderContainer = (): CSS => ({
  display: `flex`,
  justifyContent: `center`,
  alignItems: `center`,
  height: `100%`,
  paddingBottom: `100px`,
})

export const cardOuterContainer = (): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  alignItems: `space-between`,
  maxWidth: `100%`,
  height: `100%`,
  minHeight: `539px`,
})

export const title = (props: StyleProps): CSS => ({
  marginBottom: 0,
  lineHeight: props.theme.typography.body.lineHeight,
})

export const cardContainer = (): CSS => ({
  display: `flex`,
  flexDirection: `column`,
  alignItems: `space-between`,
  maxWidth: `690px`,
  height: `100%`,
})
